import { DesignServices } from '@mui/icons-material';
import { Box, Card, CardMedia, CardContent, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { theme } from 'theme/theme';

const CaratulaObra = ({
  afiche,
  nombre,
  inscripcion,
  color,
  colorTitulo,
}: {
  afiche: string;
  nombre: string;
  inscripcion?: boolean;
  color?: string;
  colorTitulo?: string;
}) => {
  const navigate = useNavigate();
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      px={{ xs: 1, md: 0 }}
      sx={{ boxSizing: 'border-box', maxHeight: { xs: '100%', md: '500px' } }}
    >
      <Card
        sx={{
          maxWidth: '400px',
          padding: '15px',
          borderRadius: 0,
          boxShadow: 'none',
          border: '1px solid lightgray',
          backgroundColor: color || theme.palette.secondary.main,
        }}
      >
        <CardMedia
          component="img"
          alt={nombre}
          image={afiche}
          title={nombre}
          sx={{ height: inscripcion ? '350px!important' : '400px!important' }}
        />
        <CardContent>
          <Typography
            pt={1}
            variant="h6"
            fontStyle="italic"
            fontSize="1.1rem"
            component="div"
            color={colorTitulo || theme.palette.primary.main}
          >
            {nombre}
          </Typography>
          {inscripcion && (
            <Button
              sx={{ mt: 2 }}
              startIcon={<DesignServices />}
              variant="contained"
              fullWidth
              onClick={() => navigate('inscripcion')}
            >
              Inscribirme
            </Button>
          )}
        </CardContent>
      </Card>
    </Box>
  );
};

export default CaratulaObra;
